export default {
    methods: {
        concat(first, second = null, glue = ' - ') {
            return second ? first + glue + second : first;
        },
        getFullPhoneNumber({CountryCode, PhoneNumber, PhoneExtension}) {
            let number = '';
            if (CountryCode) {
                number = `+${CountryCode} `;
            }

            number += PhoneNumber;

            if (PhoneExtension) {
                number += ` ${PhoneExtension}`;
            }

            return number;
        },
        getEuropeanNumberFormat(x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
            return parts.join(",");
        }
    },
};
